import { Typography } from "@mui/material";
import moment from "moment";

export default function Date(props) {
	const date = props.date;
	const format = props.format || ('YYYY-MM-DD' + (props.noTime ? '' : ' HH:mm'));
	const label = date ? moment(date).format(format) : '';
	return (
		<Typography variant={props.variant} sx={{ whiteSpace: 'nowrap' }}>{label}</Typography>
	);
}